import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <ul>
                <li>
                    <a target='_blank' href='https://cuolega.co.jp/profile/'>
                        運営会社
                    </a>
                </li>
                <li>
                    <a target='_blank' href='https://cuolega.co.jp/privacy/'>
                        プライバシーポリシー
                    </a>
                </li>
                <li>
                    <a target='_blank' href='https://cuolega.co.jp/terms/'>
                        利用規約
                    </a>
                </li>
            </ul>
            <small>
                COPYRIGHT &copy; 2023 foods labo agent by cuolega ALL RIGHTS
                RESERVED.
            </small>
        </footer>
    )
}
